module.exports = __webpack_public_path__ + "img/pf.c3dccca7.png";